import React, { createContext, useState, useContext, useEffect } from 'react';
import { getUser, isAuthenticated, logout as authLogout } from '../services/auth';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAuth, setIsAuth] = useState(false);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = () => {
    const authenticated = isAuthenticated();
    setIsAuth(authenticated);
    
    if (authenticated) {
      const userData = getUser();
      setUser(userData);
    }
    setLoading(false);
  };

  const login = (userData) => {
    setUser(userData);
    setIsAuth(true);
  };

  const logout = () => {
    authLogout();
    setUser(null);
    setIsAuth(false);
  };

  const value = {
    user,
    loading,
    isAuth,
    login,
    logout,
    checkAuth
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};